<script lang="ts" setup>
import { DropdownItem, Icon, Tooltip } from '@brighterly/lib-lumee-ui'

import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useDisciplineStore } from '@stores/discipline'

import { useBtnPlans } from '@composables/widgets/plans/btn-plans.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'

defineOptions({
  name: 'LinkPricing',
})

const props = withDefaults(defineProps<{
  view: 'dropdown-item' | 'menu-button'
  layout?: MenuButtonLayout
}>(), {
  layout: 'horizontal',
})

const emit = defineEmits<{
  click: []
}>()

// The More row reads Pricing; the demo navigation item keeps Prices.
const text = computed(() => (props.view === 'dropdown-item' ? 'Pricing' : 'Prices'))
const disciplineStore = useDisciplineStore()

const {
  selected,
  disabled,
  plansUrl,
} = useBtnPlans({})

const handleClick = (): void => {
  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_plans',
    link_text: text.value,
    href: plansUrl.value,
    discipline_code: disciplineStore.isEla
      ? Discipline.ELA
      : Discipline.Math,
  })
  emit('click')
}

const handleClickItem = (): void => {
  if (selected.value) return

  handleClick()
  if (plansUrl.value) void navigateTo(plansUrl.value)
}

const handleClickButton = (event: MouseEvent): void => {
  event.preventDefault()
  handleClick()
  if (plansUrl.value) void navigateTo(plansUrl.value)
}
</script>

<template>
  <DropdownItem
    v-if="view === 'dropdown-item'"
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    :aria-current="selected ? 'page' : undefined"
    :selected="selected"
    :disabled="disabled"
    @click="handleClickItem"
  >
    <template #leading>
      <Icon
        name="wallet"
        size="md"
        :color="disabled ? 'disabled' : 'default'"
      />
    </template>
  </DropdownItem>
  <Tooltip
    v-if="view === 'menu-button'"
    description="Prices will be available after your demo lesson"
    size="sm"
    :placement="layout === 'vertical' ? 'top' : 'bottom'"
    show-when="disabled"
  >
    <HeaderNavItem
      :layout="layout"
      icon="wallet"
      :label="text"
      :href="plansUrl ?? undefined"
      :selected="selected"
      :disabled="disabled"
      @click="handleClickButton"
    />
  </Tooltip>
</template>
